import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/common/Buttons/Button';
import { htmlToReact } from '../../../../utils/functions';
import { toFormattedLocalDate } from '../../../../utils/dateTime/converter';
import { DueDate } from '../../DueDate/DueDate';
import './Overview.scss';

export const OverviewDetails = ({ id, assessment, assessmentHelpText }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const owners = [];
  assessment?.owners.map(assessmentOwner => {
    const { firstName, lastName } = assessmentOwner;
    owners.push(`${firstName} ${lastName}`);
    return owners;
  });

  const dueDate = assessment ? assessment.dueDate : new Date();

  const showOwners = isOpen ? owners : owners.slice(0, 5);
  return (
    <React.Fragment>
      {assessment && (
        <span className="left-block">
          <div className=" details-sections info-content due-date">
            <h5 className="sidebar-header">{`${t('assessment.dueDate.due')} ${dueDate ? toFormattedLocalDate(dueDate) : t('common.noValue')}`}</h5>
            <DueDate t={t} dueDate={assessment.dueDate} />
          </div>
        </span>
      )}
      {assessmentHelpText && (
        <div data-testid={id} className="assessment-help-text">
          {htmlToReact(assessmentHelpText)}
        </div>
      )}
      {assessment && (
        <div>
          <h5 className="sidebar-header">{t('assessment.overview.details')}</h5>
          <div className="details-owner">
            <h6 className="details-label">{t('assessment.overview.ownerTitle')}</h6>
            <h6 className="details-value">
              {showOwners.map(owner => (
                <p className="owner-values" key={owner}>
                  {owner}
                </p>
              ))}
            </h6>
            {owners.length > 5 && (
              <Button className="show-more-less" buttonStyle="text" onClick={toggle}>
                {isOpen ? t('assessment.overviewDetails.showLess') : t('assessment.overviewDetails.showMore')}
              </Button>
            )}
          </div>
          <div>
            <h6 className="details-label">{t('assessment.overview.dateCreated')}</h6>
            <h6 className="details-value">{toFormattedLocalDate(assessment.lastUpdated)}</h6>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
